import React from 'react';
import { Fragment, useLayoutEffect, useRef, useState } from 'react';
import { scaleLinear } from 'd3-scale';
import { max } from 'd3-array';
import { colors } from '../../modules/theme';
import {
  startOfMonth,
  endOfMonth,
  format,
  isBefore,
  isAfter,
  addDays,
} from 'date-fns';
import { getDateForEachMonthBetweenDates } from '../../modules/date-helpers';
import { initialState, getInitialTo } from '../../modules/app-duck';
const barMaxHeight = 40;
const scale = scaleLinear().range([1, barMaxHeight]);

export default function BarChart({
  submissionsWithMonthCount,
  onBarClick,
  from,
  to,
  tab,
}) {
  const domain = max(submissionsWithMonthCount, x => x.count);
  scale.domain([0, domain]);
  const barChartRef = useRef();
  useLayoutEffect(() => {
    if (barChartRef && barChartRef.current) {
      barChartRef.current.scrollLeft = barChartRef.current.scrollWidth;
    }
  }, [barChartRef, submissionsWithMonthCount]);
  const [hoveredBar, setHoveredBar] = useState();

  return (
    <div
      ref={barChartRef}
      css={{
        display: 'flex',
        flexDirection: 'column',
        overflowX: 'auto',
        paddingBottom: 5,
        paddingTop: 5,
        marginRight: 5,
      }}
    >
      <div
        css={{
          display: 'flex',
          alignItems: 'flex-end',
          paddingTop: 12,
        }}
      >
        {getDateForEachMonthBetweenDates(
          initialState.from,
          getInitialTo(tab)
        ).map((date, i) => {
          const year = date.getFullYear();
          const month = date.getMonth();
          const data = submissionsWithMonthCount.find(x => {
            return parseInt(x.year) === year && parseInt(x.monthNum) === month;
          });
          const count = data ? data.count : 0;
          const hasData = data && data.count > 0;
          const isHighligted =
            isAfter(addDays(date, 1), from) && isBefore(date, endOfMonth(to));

          return (
            <Fragment key={i}>
              <div
                onClick={e => {
                  if (!hasData) {
                    return;
                  }
                  const newFrom = format(startOfMonth(date), 'YYYY-MM-DD');
                  const newTo = format(endOfMonth(date), 'YYYY-MM-DD');
                  if (newFrom === from && newTo === to) {
                    onBarClick({ from: undefined, to: undefined });
                  } else {
                    onBarClick({ from: newFrom, to: newTo });
                  }
                }}
                onMouseEnter={() => {
                  if (!hasData) return;
                  setHoveredBar(i);
                }}
                onMouseLeave={() => {
                  if (!hasData) return;

                  setHoveredBar();
                }}
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  margin: '0 5px',
                  alignItems: 'center',
                  cursor: hasData ? 'pointer' : 'initial',
                  opacity: isHighligted ? 1 : 0.2,
                }}
              >
                <div
                  css={{
                    borderRadius: 3.5,
                    width: 5,
                    background: colors.yellow,
                    height: count > 0 ? scale(count) : count,
                  }}
                />

                <span
                  css={{
                    fontSize: 12,
                    fontWeight: 'bold',
                    borderRadius: '100%',
                    width: 15,
                    height: 15,
                    lineHeight: '1',
                    background: hoveredBar === i ? colors.yellow : 'none',
                    color: hoveredBar === i ? 'black' : 'white',
                    marginTop: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {format(date, 'MMM').charAt(0)}
                </span>
              </div>
              {month === 11 && (
                <div
                  css={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    margin: '0  ',
                    alignItems: 'center',
                    position: 'relative',
                  }}
                >
                  <span
                    css={{
                      position: 'absolute',
                      top: 0,
                      transform: 'translateY(-100%)',
                      color: 'white',
                      fontSize: '12px',
                      fontWeight: 'bold',
                    }}
                  >
                    {year + 1}
                  </span>

                  <span
                    css={{
                      height: barMaxHeight,
                      marginBottom: 15 + 2, // the month letter is 15px high + margin top 2
                      border: `1px rgba(255,255,255,0.5) dashed`,
                      opacity: isHighligted ? 1 : 0.2,
                    }}
                  />
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
